module.exports = __webpack_public_path__ + "static/media/Prosjektskisse.eb47e216.pdf";